module.exports = __webpack_public_path__ + "assets/img/picture2.d392a84b.svg";